export default __webpack_public_path__ + "img/bg_locations-abfdab650eaa6a8d3efb463a7442f8a3.png";